import ActionTypes from '../actions/ActionTypes';
import { ApportionmentType } from '../constants';

const initialState = {

  negotiations: [],
  negotiationsSearch: '',
  orderBy: '',
  orderDirection: '',
  registerPerPage: process.env.REACT_APP_REGISTER_PER_PAGE,

  negotiationDetail: {},
  comprehensivenessOptions: [],
  naturesOptions: [],
  salesTypesOptions: [],
  salesOriginOptions: [],
  priceTableOptions: [],
  mainVehicleOptions: [],
  paymentTypeOptions: [],
  commercialPlansOptions: [],
  vehicles: [],
  abrangencia: '',
  sharepointOptions: [
    {id:1, name: 'Sim'},
    {id:2, name: 'Não'}
  ],

  clientOptions: [],
  clientSearch: '',
  //ValorVeiculo: '',

  agencyOptions: [],
  agencySearch: '',
  token: {
    profile: {}
  },

  negotiaton: {
    
    mainVehicle: {},
    saveSharepoint: '',
    justification: '',
    client: null,
    agency: null,
    commercialPlan: {},
    salesType: {},
    salesOrigin: {},
    comprehensiveness: [],
    comprehensivenessCopy: [],
    beginDate: null,
    endDate: null,
    table: {},
    totalAmount: null,
    discount: null,
    paymentType: {},
    nature: {},
    withDigital: false,
    withOthersVehicles: false,
    withreplication: false,
    creationDate: `${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`,
    executive: {
      idExecutivo: 0,
      nomeExecutivo: ''
    },
    apportionments: [],
    remainingValue: 0
  },

  loadingAgencies: false,

  apportionment: {
    vehicle: {},
    type: '',
    amount: null,
    percent: null,
    editing: false
  },




  ufs: [],
  regions: []
};

const updateRemainingValue = (apportionments, totalAmount) => {
  apportionments = apportionments || [];
  return (
    totalAmount -
    (apportionments.map(a => a.amount).reduce((a, b) => a + b, 0) || 0)
  );
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FILL_TOKEN_SUCCESS:
      return { ...state, token: action.payload };
    case ActionTypes.FILL_REGION:
      return { ...state, regions: action.payload };
    case ActionTypes.UNCHANGED_REGION:
      return {
        ...state,
        negotiaton: {
          ...state.negotiaton,
          comprehensiveness: [...state.negotiaton.comprehensiveness.filter(c => c.estado != action.payload)]
        }
      }
    case ActionTypes.UNCHECKEDS_UFS:
      return {
        ...state,
        negotiaton: {
          ...state.negotiaton,
          comprehensiveness: [...state.negotiaton.comprehensiveness.filter(c => c.regiao != action.payload)]
        }
      }
    case ActionTypes.UNCHECKED_NACIONAL:
      return {
        ...state,
        negotiaton: {
          ...state.negotiaton,
          comprehensiveness: [...state.negotiaton.comprehensiveness.filter(c => c.filiada != action.payload)]
        }
      }
    case ActionTypes.CHECKED_NACIONAL: {
      return {
        ...state,
        negotiaton: {
          ...state.negotiaton,
          comprehensiveness: [...state.negotiaton.comprehensiveness.filter(c => c.filiada != action.payload), ...state.comprehensivenessOptions.filter(c => c.filiada == action.payload)]
        }
      }
    }
    case ActionTypes.CHECKEDS_UFS: {
      return {
        ...state,
        negotiaton: {
          ...state.negotiaton,
          comprehensiveness: [...state.negotiaton.comprehensiveness.filter(c => c.regiao != action.payload), ...state.comprehensivenessOptions.filter(c => c.regiao == action.payload)]
        }
      }
    }
    case ActionTypes.CHANGED_REGION: {
      return {
        ...state,
        negotiaton: {
          ...state.negotiaton,
          comprehensiveness: [...state.negotiaton.comprehensiveness.filter(c => c.estado != action.payload), ...state.comprehensivenessOptions.filter(c => c.estado == action.payload)]
        }
      }
    }
    case ActionTypes.SEARCH_NEGOTIATIONS_SUCCESS:
      return { ...state, negotiations: action.payload };
    case ActionTypes.CLEAR_CLIENT_SEARCH:
      return { ...state, clientOptions: [] };
    case ActionTypes.SEARCH_ALL_NEGOTIATIONS_SUCCESS:
      return {
        ...state,
        negotiations: action.payload.negotiations,
        registerPerPage: action.payload.registerPerPage
      };
    case ActionTypes.REDIRECT_TO_REGISTER_APPORTIONMENT:
      return {
        ...state,
        apportionment: {
          ...initialState.apportionment,
          type: action.payload,
          vehicle:
            action.payload === ApportionmentType.Digital
              ? { id: 51, nome: 'Digital' }
              : {}
        }
      };
    case ActionTypes.UPDATE_REMAINING_VALUE:
      return {
        ...state,
        negotiaton: {
          ...state.negotiaton,
          remainingValue: updateRemainingValue(
            state.negotiaton.apportionments,
            state.negotiaton.totalAmount
          )
        }
      };

    case ActionTypes.FILL_EXECUTIVE_SUCCESS:
      return {
        ...state,
        negotiaton: { ...state.negotiaton, executive: action.payload }
      };

      case ActionTypes.CHANGE_SAVE_SHAREPOINT:
        return {
          ...state,
          negotiaton: { ...state.negotiaton, saveSharepoint: action.payload }
        };

        case ActionTypes.CHANGE_TEXT_SHAREPOINT:
          return {
            ...state,
            negotiaton: { ...state.negotiaton, justification: action.payload }
          };

    case ActionTypes.SELECT_VEHICLES_TYPE:
      return {
        ...state,
        apportionment: { ...state.apportionment, vehicle: action.payload }
      };

    case ActionTypes.SORT_NEGOTIATION_LIST:
      return {
        ...state,
        orderBy: action.payload.column,
        orderDirection: action.payload.direction
      };
    case ActionTypes.FILL_PAYMENT_TYPES_SUCCESS:
      return { ...state, paymentTypeOptions: action.payload };
    case ActionTypes.FILL_UFS:
      return { ...state, ufs: action.payload };
    case ActionTypes.FILL_COMPREHENSIVENESS_SUCCESS:
      return { ...state, comprehensivenessOptions: action.payload };
    case ActionTypes.FILL_VEHICLES_SUCCESS:
      return { ...state, vehicles: action.payload };
    case ActionTypes.FILL_MAINVEHICLES:
      return { ...state, mainVehicleOptions: action.payload };
    case ActionTypes.UPDATE_MAINVEHICLE:
      return {...state,
         negotiaton: {...state.negotiaton, mainVehicle:action.payload}
      }
    case ActionTypes.FILL_COMMERCIAL_PLANS_SUCCESS:
      return { ...state, commercialPlansOptions: action.payload };
    case ActionTypes.FILL_NEGOTIATION_DETAIL_SUCCESS:
      return { ...state, negotiationDetail: action.payload };
    case ActionTypes.FILL_NATURES_SUCCESS:
      return { ...state, naturesOptions: action.payload };
    case ActionTypes.UPDATE_INPUT_FILTER:
      return { ...state, negotiationsSearch: action.payload };
    case ActionTypes.FILL_SALES_TYPE_SUCCESS:
      return { ...state, salesTypesOptions: action.payload };
    case ActionTypes.UPDATE_SALESORIGIN:
      return {
        ...state,
        negotiaton: { ...state.negotiaton, salesOrigin: action.payload },
        };

    case ActionTypes.FILL_SALESORIGIN_TYPE_SUCCESS:
      return { ...state, salesOriginOptions: action.payload };

    case ActionTypes.FILL_PRICE_TABLE_SUCCESS:
      return { ...state, priceTableOptions: action.payload };
    case ActionTypes.SELECTED_CLIENT:
      return {
        ...state,
        negotiaton: { ...state.negotiaton, client: action.payload },
        clientSearch: `${action.payload.nome || action.payload.razaoSocial} - ${action.payload.uf || ''} - ${action.payload.cidade || ''} - ${action.payload.cnpj || action.payload.cpf || ''} - ${action.payload.logradouro || ''}, ${action.payload.numero || ''}`
      };
    case ActionTypes.SELECTED_AGENCY:
      return {
        ...state,
        negotiaton: { ...state.negotiaton, agency: action.payload }
      };
    case ActionTypes.CLEAR_AGENCY_OPTIONS:
      return {
        ...state,
        agencyOptions: [],
        negotiaton: { ...state.negotiaton }
      };
    case ActionTypes.CLEAR_CLIENT_OPTIONS:
      return {
        ...state,
        clientOptions: [],
        negotiaton: { ...state.negotiaton, client: null }
      };

    case ActionTypes.CLEAR_APPORTIOMENT_FIELDS:
      return {
        ...state,
        apportionment: {
          ...state.apportionment,
          vehicle: {},
          amount: null,
          percent: null
        }
      };
    case ActionTypes.FILL_APPORTIOMENT:
      return { ...state, apportionment: { ...action.payload, editing: true } };
    case ActionTypes.CLEAR_NEGOTIATION:
    case ActionTypes.SAVE_NEGOTIATION_SUCCESS:
      return {
        ...state,
        negotiaton: initialState.negotiaton,
        clientOptions: [],
        clientSearch: '',
        agencyOptions: [],
        agencySearch: ''
      };
    case ActionTypes.CLEAR_APPORTIONMENT:
      return {
        ...state,
        negotiaton: { ...state.negotiaton, apportionments: [] }
      };
    case ActionTypes.CLEAR_DIGITAL:
      return {
        ...state,
        negotiaton: {
          ...state.negotiaton,
          apportionments: state.negotiaton.apportionments.filter(
            a => a.type !== ApportionmentType.Digital
          )
        }
      };
    case ActionTypes.CLEAR_OTHERS_VEHICLES:
      return {
        ...state,
        negotiaton: {
          ...state.negotiaton,
          apportionments: state.negotiaton.apportionments.filter(
            a => a.type !== ApportionmentType.OtherVehicle
          )
        }
      };
    case ActionTypes.CHANGED_CLIENT_SEARCH:
      return { ...state, clientSearch: action.payload };
    case ActionTypes.CHANGED_AGENCY_SEARCH:
      return { ...state, agencySearch: action.payload, loadingAgencies: action.payload ? true : false };
    case ActionTypes.UPDATE_NEGOTIATION_CLIENT_OPTIONS_SUCCESS:
      return {
        ...state,
        clientOptions: action.payload,
        negotiaton: { ...state.negotiaton, client: null }
      };
    case ActionTypes.UPDATE_NEGOTIATION_AGENCY_OPTIONS_SUCCESS:
      return {
        ...state,
        agencyOptions: action.payload.map(agency => {return { ...agency, value: agency.id, label: `${agency.nome || agency.razaoSocial} - ${agency.uf || ''} - ${agency.cidade || ''} - ${agency.cnpj || agency.cpf || ''} - ${agency.logradouro || ''}, ${agency.numero || ''}`}}),
        negotiaton: { ...state.negotiaton },
        loadingAgencies: false
      };
    case ActionTypes.SHOW_SELECT_COMPREHENSIVENESS:
      return {
        ...state,
        negotiaton: {
          ...state.negotiaton,
          comprehensivenessCopy: state.negotiaton.comprehensiveness,

        },
      };
    case ActionTypes.CHECKED_COMPREHENSIVENESS:
      return {
        ...state,
        negotiaton: {
          ...state.negotiaton,
          comprehensiveness: [
            ...state.negotiaton.comprehensiveness,
            action.payload
          ]
        }
      };
    case ActionTypes.UNCHECKED_COMPREHENSIVENESS:
      return {
        ...state,
        negotiaton: {
          ...state.negotiaton,
          comprehensiveness: state.negotiaton.comprehensiveness.filter(
            c => c.id !== action.payload.id
          )
        }
      };
    case ActionTypes.UPDATE_NEGOTIATION_EDIT_FIELD:
      return {
        ...state,
        negotiaton: {
          ...state.negotiaton,
          [action.payload.prop]: action.payload.value
        }
      };
    case ActionTypes.UPDATE_APPORTIONMENT_FIELD:
      return {
        ...state,
        apportionment: {
          ...state.apportionment,
          [action.payload.prop]: action.payload.value
        }
      };




    case ActionTypes.UPDATE_APPORTIONMENT_AMOUNT_FIELD:
      return {
        ...state,
        apportionment: {
          ...state.apportionment,
          amount: action.payload.amountValue,
          percent: action.payload.percentvalue
        }
      };
    case ActionTypes.REVOKE_SELECT_COMPREHENSIVENESS:
      return {
        ...state,
        negotiaton: {
          ...state.negotiaton,
          comprehensiveness: state.negotiaton.comprehensivenessCopy
        }
      };
    case ActionTypes.SAVE_APPORTIOMENT:
      const newApportionments = [
        ...state.negotiaton.apportionments,
        action.payload
      ];
      return {
        ...state,
        negotiaton: {
          ...state.negotiaton,
          apportionments: newApportionments,
          remainingValue: updateRemainingValue(
            newApportionments,
            state.negotiaton.totalAmount
          )
        }
      };
    case ActionTypes.REMOVE_APPORTIOMENT:
      const newApportionmentsRemoved = state.negotiaton.apportionments.filter(
        a => a.vehicle.id !== action.payload.vehicle.id
      );
      return {
        ...state,
        negotiaton: {
          ...state.negotiaton,
          apportionments: newApportionmentsRemoved,
          remainingValue: updateRemainingValue(
            newApportionmentsRemoved,
            state.negotiaton.totalAmount
          )
        },
        apportionment: initialState.apportionment
      };
    default:
      return state;
  }
};
